/**
 * Created by jonas on 2021-03-10.
 */
import {GraphicsPool} from "../../utils/GraphicsPool";
import {DasUBootGameAssets} from "../../DasUBootGameAssets";
import {DasUBoot} from "../../DasUBoot";
import {SpineGSAPWrapper} from "../../../core/animation/SpineGSAPWrapper";
import {LoopableList} from "../../utils/LoopableList";
import {gsap} from "gsap";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {DasUBootSound} from "../../sound/DasUBootSound";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {DasUBootStatics} from "../../utils/DasUBootStatics";

export class PeriscopeView {
    public view:PIXI.Container;
    private readonly _spine:PIXI.spine.Spine;
    private readonly _crossHair:PIXI.Sprite;
    private readonly _textField:PIXI.Text;
    private readonly _mainContainer:PIXI.Container;
    private readonly _hitChance:PIXI.Text;
    private readonly _background:PIXI.Sprite;

    private shipSkins:LoopableList<string> = new LoopableList<string>([
        "ship2",
        "ship3",
        "ship4",
        "ship5",
        "ship6",
    ]).setRandomizeAtWrapAround(true);

    public static missAnimations = new LoopableList<string>([
        "miss_0",
    ]);

    public static missTexts = new LoopableList<{text:string, sound:string}>([
        {text:"VERDAMMT", sound:DasUBootSound.PERISCOPE_MISS_VERDAMMT},
        {text:"SCHEISSE", sound:DasUBootSound.PERISCOPE_MISS_SCHEISSE},
        {text:"MIST", sound:DasUBootSound.PERISCOPE_MISS_MIST},

    ]).setRandomizeAtWrapAround(true);

    public static hitAnimations = new LoopableList<string>([
        "hit_0",
    ]);

    constructor() {
        this.view = new PIXI.Container();
        this._mainContainer = new PIXI.Container();
        this._mainContainer.name = "periscopeShootMainContainer"

        const radius = 303;

        this._background = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._background.name = "periscopeShootBackground";
        this._background.tint = 0x000000;
        this._background.anchor.set(0.5,0.5);
        this._background.alpha = 0.0;

        this._spine = GraphicsPool.spineFactory(DasUBootGameAssets.PERISCOPE_SPINE);
        this._spine.autoUpdate = false;
        this.setSkin();

        this._crossHair = new PIXI.Sprite(DasUBoot.assetLoader.getTextures(DasUBootGameAssets.PERISCOPE_CROSS_HAIR)[0]);
        this._crossHair.anchor.set(0.5, 0.5);

        const mask = new PIXI.Graphics();
        mask.beginFill(0xff0000, 0.3);
        mask.drawCircle(0, 0, radius - 6);
        mask.endFill();
        this._spine.mask = mask;


        const style:PIXI.TextStyle = new PIXI.TextStyle({
            fill:0xffffff,
            fontFamily:OpenSans.FAMILY,
            wordWrap:false,
            fontWeight:FontWeight.BOLD,
            fontSize:100,
            dropShadow:true,
            dropShadowAngle:1.5,
            dropShadowBlur:5,
            dropShadowDistance:10,
            lineJoin: "round",
            strokeThickness: 12
        });

        this._textField = new PIXI.Text("", style);
        this._textField.anchor.set(0.5,0.1);
        this._textField.position.set(0,90);
        this._textField.alpha = 0;


        const hitChanceStyle:PIXI.TextStyle = new PIXI.TextStyle({
            fill:0x000000,
            fontFamily:OpenSans.FAMILY,
            wordWrap:false,
            fontWeight:FontWeight.BOLD,
            fontSize:18,
/*            dropShadow:true,
            dropShadowAngle:1.5,
            dropShadowBlur:2,
            dropShadowDistance:2,
            lineJoin: "round",
            strokeThickness: 2*/
        });

        this._hitChance = new PIXI.Text("Hit chance: ", hitChanceStyle);
        this._hitChance.anchor.set(0,0);
        this._hitChance.position.set(-160,-200);


        this._spine.state.addListener({
            event:(entry, event) => {
                if (event.data.name == "miss"){
                    this.onMissEvent();
                } else if (event.data.name == "hit"){
                    this.onHitEvent();
                }
            }
        });

        this._mainContainer.addChild(this._spine);
        this._mainContainer.addChild(this._crossHair);
        this._mainContainer.addChild(mask);
        this._mainContainer.addChild(this._textField);
        this._mainContainer.addChild(this._hitChance);
        this.view.addChild(this._background);
        this.view.addChild(this._mainContainer);

        this._mainContainer.scale.set(0,0);
        this._mainContainer.visible = false;

    }

    private setSkin() {
        const newSkinName = this.shipSkins.next();
        this._spine.skeleton.setSkinByName(newSkinName);
        this._spine.skeleton.setToSetupPose();
        const scale = Math.random() > 0.5 ? 1 : -1;
        this._spine.scale.set(scale,1);
    }


    public backgroundAnimation(duration:number, toAlpha:number){
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(gsap.to(this._background, {duration:0.2, pixi:{alpha:toAlpha}}));
        return tl;
    }

    public getShootAnimation(hitChance:number, didHit:boolean):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(()=>{
            this._hitChance.text = `Hit chance: ${hitChance}%`;
            this._mainContainer.visible = true;
        });

        const animationName:string = didHit ? PeriscopeView.hitAnimations.next() : PeriscopeView.missAnimations.next();

        tl.add([
            gsap.to(this._mainContainer, {duration:0.2, pixi:{scale:1}}),
            SpineGSAPWrapper.createTimelineForAnimation(this._spine, 0, animationName)
        ]);
        tl.add([
            gsap.to(this._mainContainer, {duration:0.7, pixi:{scale:0}}),
            gsap.to(this._background, {duration:0.7, pixi:{alpha:0.0}}),
        ]);

        tl.add(()=>{
            SpineGSAPWrapper.clearAnimation(this._spine,0);
            this._mainContainer.visible = false;
            this.setSkin();
        });
        return tl;
    }

    public onMissEvent():gsap.core.Timeline{
        const tl:gsap.core.Timeline = gsap.timeline();
        const data = PeriscopeView.missTexts.next();
        tl.add(()=>{
            this._textField.text = data.text;
            this._textField.alpha = 0;
            this._textField.scale.set(2,2);
            this._textField.rotation = -0.2;
        });

        tl.add(()=>DasUBoot.soundPlayer.playSound(data.sound));
        tl.add(gsap.to(this._textField, {duration:0.05,alpha:1}));
        tl.add(gsap.to(this._textField, {duration:0.8, ease:"elastic.out(1, 0.5)", pixi:{scale:1,}}), "<");
        tl.add(gsap.to(this._textField, {duration:0.6, ease:"power2.out", rotation:0.08}), "<0.2");
        tl.add(gsap.to(this._textField, {duration:0.5, ease:"power2.inOut", rotation:-0.05}));
        tl.add(gsap.to(this._textField, {duration:0.3,alpha:0}), ">1");

        return tl;
    }

    public onHitEvent():gsap.core.Timeline{
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(()=>DasUBoot.soundPlayer.playSound(DasUBootSound.PERISCOPE_HIT))
        tl.add(gsap.to(this._mainContainer, {
            duration:0.5,
            x:"-=30",
            ease:DasUBootStatics.periscopeHitWiggleX
        }));
        tl.add(gsap.to(this._mainContainer, {
            duration:0.5,
            y:"-=30",
            ease:DasUBootStatics.periscopeHitWiggleY
        }),"<");

        tl.add(gsap.to(DasUBoot.reelView, {
            duration:0.5,
            x:"-=10",
            ease:DasUBootStatics.periscopeHitWiggleY
        }),"<");
        tl.add(gsap.to(DasUBoot.reelView, {
            duration:0.5,
            y:"-=10",
            ease:DasUBootStatics.periscopeHitWiggleX
        }),"<");


        tl.add(()=>{this._background.tint = 0xffffff}, "<");
        tl.add(gsap.to(this._background, {duration:0.4, pixi:{tint:0x000000}}), ">");


        return tl;
    }

    public resizeBackground(mainContainerScale:number, position:PIXI.Point){
        this._background.width = NolimitApplication.screenBounds.width;
        this._background.height = NolimitApplication.screenBounds.height;
        this._background.position.set(
            position.x - this.view.position.x,
            position.y - this.view.position.y
        );
        this._background.scale.x = this._background.scale.x * (1/mainContainerScale) * 1.2;
        this._background.scale.y = this._background.scale.y * (1/mainContainerScale) * 1.2;
    }


}